unable to read source [project]/node_modules/src/zxing-html5-qrcode-decoder.ts